import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'app-content-module',
  templateUrl: './content-module.component.html',
  styleUrls: ['./content-module.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentModuleComponent {
  @Input() borderPosition = 'left';
  @Input() isInteractive = false;
}
